import "./App.css";
import "./Style/Dashboard.css";
import "./Style/Login.css";
import "./Style/Home.css";
import Login from "./Page/Login/login";
import Dashboard from "./Page/Dashboard/dashboard";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./Router/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Home from "./Page/Home/Home";
import DeliveryReceipt from "./Page/DeliveryReceipt/dashboard";
import DashboardV2 from "./Page/DashboardV2/dashboardV2";
import MicrosoftCallback from "./Page/Auth/MicrosoftCallback";
import { AuthProvider } from "./Context/AuthContext";

function App() {
  return (
    <div className="App">
      <ToastContainer />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/auth/callback" element={<MicrosoftCallback />} />
            <Route path="/login" element={<MicrosoftCallback />} />
            <Route path="/home" element={<ProtectedRoute Component={Home} />} />
            <Route
              exact
              path="/dashboard"
              element={<ProtectedRoute Component={Dashboard} />}
            />
            <Route
              exact
              path="/dashboard-v2"
              element={<ProtectedRoute Component={DashboardV2} />}
            />
            <Route
              exact
              path="/delivery-receipt"
              element={<ProtectedRoute Component={DeliveryReceipt} />}
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
